import { createRoot } from 'react-dom/client';
import Container from '../components/Container';

const root = createRoot(document.getElementById('root'));
root.render(<Container />);
